import script from "./FamilyPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./FamilyPanel.vue?vue&type=script&setup=true&lang=js"

import "./FamilyPanel.vue?vue&type=style&index=0&id=29147b50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.32_webpack@5.106.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29147b50"]])

export default __exports__